import { getJourneyScrollGate } from "@/journeyScrollGate";
import { isMobileAnchorNavigationActive } from "@/mobileAnchorNav";
import { isMobileViewport } from "@/mobileScrollHub";

/** Ease touch delta near story gate bounds — mobile only. */
export function softenMobileScrollDeltaAtBounds(deltaY, scrollY, bounds) {
  if (!bounds || deltaY === 0) return deltaY;
  const next = scrollY + deltaY;
  const zone = 68;
  const boundaryBleed = 0.4;
  if (deltaY > 0 && next > bounds.maxScrollY) {
    const room = bounds.maxScrollY - scrollY;
    if (room <= 0) return deltaY * boundaryBleed;
    const over = next - bounds.maxScrollY;
    if (over >= zone) return Math.min(deltaY, room);
    return deltaY * (1 - (over / zone) * 0.35);
  }
  if (deltaY < 0 && next < bounds.minScrollY) {
    const room = bounds.minScrollY - scrollY;
    if (room <= 0) return deltaY * boundaryBleed;
    const over = bounds.minScrollY - next;
    if (over >= zone) return Math.max(deltaY, room);
    return deltaY * (1 - (over / zone) * 0.35);
  }
  return deltaY;
}

/** Active mobile section scroll clamp (journey, ai-tutor, …). */
export function getActiveMobileScrollGate() {
  if (!isMobileViewport() || isMobileAnchorNavigationActive()) return null;
  return getJourneyScrollGate();
}
